import React, { Component } from 'react';
import { Segment, Header, List } from 'semantic-ui-react';

export default class CourseStructure extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as='h1' content="Course Structure" />

        <p>
          At a high level, the course will consist of the following parts:
        </p>

        <List ordered>
          <List.Item>
            <b>Lectures</b>:
            I will teach you about the intellectual foundations of usable privacy and security
            research through a series of short lectures.
          </List.Item>
          <List.Item>
            <b>Readings</b>:
            <List ordered>
              <List.Item>
                <i>Commentaries</i>:
                  If you are attending lecture, you will submit three discussion prompts for each of the assigned readings.
                  If you are unable to attend lecture, you will submit thoughtful commentaries on each of the assigned readings.
                  These will be due on Canvas the night before lecture (Monday nights and Wednesday nights).
              </List.Item>
              <List.Item>
                <i>Discussion lead</i>:
                You will lead the discussion of the readings for one class period. This will consist of a short presentation of
                key concepts for the readings of that lecture, along with three thoughtful discussion prompts to engage the 
                class in discussion.
              </List.Item>
            </List>
          </List.Item>
          <List.Item>
            <b>Group research project</b>:
              In a small group of 3-4, you will conduct an original research project in usable privacy
              and security throughout the semester. With your groupmates, you will write a research
              paper on this project and present it to the class. Leading up to this final paper and
              presentation, there will be interim deadlines to ensure steady progress.
          </List.Item>
        </List>
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/course-structure.js